import { useMutation } from 'react-query';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { openApiHandler } from '../../../services/http.service';

interface VerifySsnCardProps {
  email: string;
  ssn: string;
  cardLastFourDigits: string;
}
export interface VerifySsnCardReturn {
  newPhoneNumberResponseCustomData: {
    stateToken: string;
  };
}

export const useVerifySsnCardMutation = (
  onSuccess: (response: VerifySsnCardReturn) => void,
  onError: (error: any) => void,
) =>
  useMutation(
    'verifySSnCard',
    async ({ email, ssn, cardLastFourDigits }: VerifySsnCardProps): Promise<VerifySsnCardReturn> => {
      // eslint-disable-next-line no-useless-catch
      try {
        const data = await openApiHandler(`${BASE_URL}/api/v2/user/openauth/phone/change`, 'POST', { email, ssn, cardLastFourDigits } as VerifySsnCardProps);
        return data as VerifySsnCardReturn;
      } catch (e) {
        throw e;
      }
    },
    {
      onSuccess: (data: VerifySsnCardReturn) => onSuccess(data),
      onError: (error: IServerErrorResponse) => {
        onError(flattenServerErrorResponse(error));
      },
    },
  );
